var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full"},[_c('viewer-page-design',{ref:"refViewerPageDesign",attrs:{"entity-id":_vm.solarPlantId,"entity-type":'solar-plant',"work-layer":_vm.workLayer,"binary-only":true,"can-actions-pictogram":_vm.canActionsPictogram}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }